// extracted by mini-css-extract-plugin
module.exports = {"root":"Image_root__d3aBr","lazy":"Image_lazy__tutlP","loaded":"Image_loaded__9ZaHQ"};